import { render, staticRenderFns } from "./TakipHazirlaVekaletEkleDialog.vue?vue&type=template&id=2be36e11&scoped=true"
import script from "./TakipHazirlaVekaletEkleDialog.vue?vue&type=script&lang=ts"
export * from "./TakipHazirlaVekaletEkleDialog.vue?vue&type=script&lang=ts"
import style0 from "./TakipHazirlaVekaletEkleDialog.vue?vue&type=style&index=0&id=2be36e11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be36e11",
  null
  
)

export default component.exports